<template>
    <div class="ui longer flip small modal scanner">
        <ScannerMain :is_modal="true"></ScannerMain>
    </div>
</template>

<script>
import ScannerMain from './main.vue'

export default {
    name: "ScannerModal",
    props: {
    },
    data() {
        return {
            is_mobile_width: false,
            console_log_content: "",
            console_log_theme_path: "",
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider
        },
        style() {
            return this.$store.state.style
        },
        service_config() {
            return this.$store.state.provider.service_config
        },
        service_name() {
            return this.current_store.node.service_name
        },
        scanner_module_store() {
            return this.$store.state.provider.scanner_module
        },
    },
    mounted() {
        this.init()
    },
    watch: {
        is_mobile_width: {
            immediate: true,
            handler: function (value) {
                this.$nextTick(() => {
                    var theme = this.scanner_module_store.config.theme
                    var drive_name = (value) ? "mobile" : "computer"
                    if (theme[drive_name]) {
                        var background_position = (theme[drive_name].background_position) ? theme[drive_name].background_position+' / cover' : '0% 0%'

                        this.scanner_module_store.config.theme.background = (theme.color.background_img)
                            ? 'url(/images/scanner_background/'+theme.color.background_img+') '+ background_position + ' #1b1c1d'
                            : theme.color.background
                    }
                })
            },
        }
    },
    methods: {
        async init() {
            try {
                await this.set_is_mobile_width()
                await this.set_scanner_theme()
                await this.set_scanner_setting()
                await this.set_scanner_setting_groups()
                // await this.set_scanner_setting_groups()
                await new Promise(resolve => {
                    console.log(
                        "//=============== \n" +
                        "  Now scanner configs: \n" +
                        this.console_log_content + "\n" +
                        "  About setting file path: config/services/"+this.service_name+"/scanner/ \n" +
                        "  About theme file path: "+this.console_log_theme_path+" \n" +
                        "//=============== \n"
                    )
                    resolve()
                })
            } catch (e) {
                console.log(e)
            }
        },
        set_is_mobile_width() {
            this.is_mobile_width = (this.style.width <= 767)
                ? true
                : false

            $(window).resize(() => {
                this.is_mobile_width = (this.style.width <= 767)
                    ? true
                    : false
            })

            return Promise.resolve()
        },
        set_scanner_theme() {
            var file_name, file, result, theme_name

            try {
                /*
                 * 載入 Scanner theme 種類 如果沒有就吃services 內預設樣式
                 * 各個種類 才會再去抓取細項
                **/
                var nodes = require("./themes/node.json")
                result = _.findLast(nodes, (node) => {
                    return node.identity == this.$store.state.provider.node.identity
                })

                if (result && result.theme_file_name) {
                    theme_name = result.theme_file_name
                    this.console_log_theme_path = "components/scanner/provider/themes/node.json"
                } else {
                    theme_name = this.service_config.scanner_theme
                    this.console_log_theme_path = "config/services/"+this.service_name+"/config.json"
                }

                if (!theme_name) {
                    throw "Scanner theme file not find"
                }

                file_name = theme_name+".json"
                file = require("./themes/"+file_name)
                result = file
            } catch (err) {
                /*
                 * 載入 default theme
                **/
                file_name = "default.json"
                result = require("./themes/default.json")
                this.console_log_theme_path = "components/scanner/provider/themes/default.json"
                console.log(err)
            } finally {
                this.scanner_module_store.config.theme = result
                this.console_log_content += "    theme: " + file_name + "\n"
            }

            try {
                var theme = this.scanner_module_store.config.theme
                var drive_name = (this.is_mobile_width) ? "mobile" : "computer"
                if (theme[drive_name]) {
                    var background_position = (theme[drive_name].background_position) ? theme[drive_name].background_position+' / cover' : '0% 0%'

                    this.scanner_module_store.config.theme.background = (theme.color.background_img)
                        ? 'url(/images/scanner_background/'+theme.color.background_img+') '+ background_position + ' #1b1c1d'
                        : theme.color.background
                }
            } catch (err) {
                console.log(err)
            }

            return Promise.resolve()
        },
        set_scanner_setting() {
            var file_name, file, result
            try {
                if (!this.service_name) {
                    throw "Scanner settings file not find"
                }
                file_name = this.service_name+"/scanner/settings.json"
                file = require("../../../config/services/"+file_name)
                result = file
            } catch (err) {
                /*
                 * 載入 default theme
                **/
                file_name = "default/scanner/settings.json"
                result = require("../../../config/services/"+file_name)
            } finally {
                this.scanner_module_store.config.settings = result.options
                this.console_log_content += "    settings: " + file_name + "\n"
            }
            return Promise.resolve()
        },
        set_scanner_setting_groups() {
            try {
                if (!this.service_name) {
                    throw "Scanner setting groups file not find"
                }

                var file_name = this.service_name+"/scanner/setting_groups.json"
                var file = require("../../../config/services/"+file_name)
                this.scanner_module_store.setting_groups = file
            } catch (err) {
                /*
                 * 載入 default setting_groups
                **/
                file_name = "default/scanner/setting_groups.json"
                this.scanner_module_store.setting_groups = require("../../../config/services/"+file_name)
                console.log(err)
            } finally {
                this.console_log_content += "    setting_groups: " + file_name + "\n"
            }
            return Promise.resolve()
        },
    },
    components: {
        ScannerMain,
    },
}
</script>

<style lang="scss" scoped>
/* Mobile */
@media only screen and (max-width: 767px) {
    .ui.modals {
        padding: 0;
        overflow-y: hidden;
    }
    .ui.modal.scanner {
        width: 100% !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        border-radius: 0;
    }
    .ui.modal.scanner > .content {
        min-height: 100vh;
        border-radius: 0;
    }
    .modals.dimmer .ui.scrolling.modal{
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }
}

.ui.modal.scanner {
    box-shadow: none !important;
    margin-top: 0 !important;
    background-color: rgba(28, 28, 28, 0.9);
    overflow: auto;
    position: absolute;
    top: 5%;
    left: 0;
    right: 0;
    margin: 0 auto;
}

.scanner.modal .inverted {
    background-color: var(--inverted-color);
    color: white;
}
.ui.modal>.content {
    background: none;
}
</style>
